import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// /// Don't call this default export alias 'i18n' as that is used elsewhere
i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next);
/// init called in init section in index.tsx
// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
//   .init({
//     fallbackLng: 'en',
//     debug: true,

//     interpolation: {
//       escapeValue: false, // not needed for react as it escapes by default
//     },
//   // tslint:disable-next-line: no-console
//   }).catch(err => console.log("i18next init() failed", err));

// // tslint:disable-next-line: no-default-export
// export default i18next;

export const i18next = i18n;



// WEBPACK FOOTER //
// ./src/internationalization/i18next.ts